import { Identifiable, Group } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditRequest(
  group: Identifiable<Group>,
  { nextGroup, group: r }: Boundaries["editResourceGroup"]["request"],
): Identifiable<Group> {
  return r.uuid === group.uuid ? { ...group, ...nextGroup } : group;
}

function handleEditSuccess(
  group: Identifiable<Group>,
  nextGroup: Boundaries["editResourceGroup"]["success"],
): Identifiable<Group> {
  return nextGroup.uuid === group.uuid ? nextGroup : group;
}

function handleEditFailure(
  group: Identifiable<Group>,
  { group: r }: Boundaries["editResourceGroup"]["failure"],
): Identifiable<Group> {
  return r.uuid === group.uuid ? r : group;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
